import { StandardItem } from "./StandardItem.component";

export { StandardItem };
